"use client"
import { locale } from "@locale";
import transformAgeRatings from "src/lib/locale/transformAgeRatings";
import styles from "./AgeRating.module.css";
import { useEffect, useRef, useState } from "react";
import classNames from "classnames";


//#region [Props]
type AgeRatingProps = {
    reason?: string;
    age?: string;
    recommendedAge?: string;
};
//#endregion

//#region [Component]
export default function AgeRating({ reason, age, recommendedAge }: AgeRatingProps) {
    const ref = useRef<HTMLDivElement>(null);
    const [isClamped, setIsClamped] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);


    useEffect(() => {
        const el = ref.current;
        if (el) {
            setIsClamped(el.scrollHeight > el.clientHeight);
            setIsExpanded(el.scrollHeight <= el.clientHeight);
        }
    }, [reason]);

    if (!age) {
        return null;
    }
    return <div>
        <div><span>{locale.filmomtale.ageRating} {reason ? locale.filmomtale.ageRatingWithReason : ""}:</span> {transformAgeRatings(age)} {recommendedAge && <>(passer for {recommendedAge})</>}</div>
        {reason && <>
            <div id="age-rating-reason" onClick={() => setIsExpanded(true)} className={classNames({ [styles.Reason]: !isExpanded })} ref={ref}>{reason}</div>
            {isClamped && !isExpanded && <button aria-expanded={isExpanded} aria-controls="age-rating-reason" className={styles.ExpandButton} onClick={() => setIsExpanded(true)}>{locale.filmomtale.ageReasonExpand}</button>}
        </>}
    </div>
}
//#endregion

//#region [Styles]

//#endregion
